import Http from './axios';

let api = {
    get: (url, params, success, error) => {
        return Http.get(url, { params: params }).then(success).catch(error);
    },
    post: (url, params, success, error) => {
        return Http.post(url, params).then(success).catch(error);
    },
	put: (url, params, success, error) => {
	    return Http.put(url, params).then(success).catch(error);
	},
	delete: (url, params, success, error) => {
	    return Http.delete(url, {data:params}).then(success).catch(error);
	},
    http: {
        get: (url, param) => {
            return Http.get(url, { params: param }).catch(function (err) { });
        },
        post: (url, param) => {
            return Http.post(url, param).catch(function (err) { });
        },
		put: (url, param) => {
		    return Http.put(url, param).catch(function (err) { });
		},
		delete: (url, param) => {
		    return Http.delete(url, {data:params}).catch(function (err) { });
		}
    }



}
export default {
    install: Vue => {
        Vue.api = api,
            Vue.prototype.$api = api
    }
}